import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Wallboard from "./pages/Wallboard";
import AdminPage from "./pages/AdminPage";
import AuthCallback from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Google sign-in returns with #session_id=… – exchange it before any protected route renders
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Wallboard />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-center" theme="light" offset={72} visibleToasts={4} />
    </BrowserRouter>
  );
}

export default App;
